export const getPrioritiesConstants = {
  PRIORITIES_ORDERS_REQUEST: "PRIORITIES_ORDERS_REQUEST",
  PRIORITIES_ORDERS_SUCCESS: "PRIORITIES_ORDERS_SUCCESS",
  PRIORITIES_ORDERS_FAILURE: "PRIORITIES_ORDERS_FAILURE"
};
